import { render, staticRenderFns } from "./CommonQuestionsRegister.vue?vue&type=template&id=90bcd954&scoped=true"
import script from "./CommonQuestionsRegister.vue?vue&type=script&lang=js"
export * from "./CommonQuestionsRegister.vue?vue&type=script&lang=js"
import style0 from "./CommonQuestionsRegister.vue?vue&type=style&index=0&id=90bcd954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bcd954",
  null
  
)

export default component.exports